module.exports = __webpack_public_path__ + "img/img2.581afc55.svg";